import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const JsonLdInjector = ({ json }) => {
    const value = JSON.stringify(json);
    if (value.search(/<\\?script/i) !== -1) {
        return _jsx(_Fragment, {});
    }
    return _jsx("script", { type: "application/ld+json", dangerouslySetInnerHTML: { __html: value } });
};
